type ErrorLevel = 'error' | 'warn';

interface ReportClientErrorInput {
  message: string;
  stack?: string;
  source: string;
  level?: ErrorLevel;
  metadata?: Record<string, unknown>;
}

let isReporting = false;

export async function reportClientError(input: ReportClientErrorInput): Promise<void> {
  if (isReporting) {
    return;
  }

  const { message, stack, source, level = 'error', metadata = {} } = input;
  if (!message) {
    return;
  }

  try {
    isReporting = true;

    await fetch('/api/errors/client', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        message,
        stack,
        source,
        level,
        metadata,
        url: window.location.href,
        userAgent: navigator.userAgent,
      }),
    });
  } catch {
    // Swallow reporting failures to avoid affecting user flows
  } finally {
    isReporting = false;
  }
}
